import type { UserStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  status: UserStatus;
};

export const UserStatusCell = ({ status }: Props) => {
  const { t } = useResource();

  return <>{t(Resources.Form.UserStatus[status] || "")}</>;
};
